import { useRef, useMemo, useCallback } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_WMS1020_R01 } from "./Content_WMS1020_R01";
import { Info_WMS1020_R01 } from "./Info_WMS1020_R01";
import { useWMS1020_R01Store } from "./Store_WMS1020_R01";
import { AgGridReact } from "ag-grid-react";
import { WMS1020_R01DetailDto, WMS1020_R01Dto, WMS1020_R01HeaderDto, WMS1020_R01LotDto } from "./Dto_WMS1020_R01";
import SearchSection_WMS1020_R01 from "./SearchSection_WMS1020_R01";
import { Table_WMS1020_R01 } from "./Table_WMS1020_R01";
import { LabelPrintButton } from "src/components/common/LabelPrintButton";
import { DetailTable_WMS1020_R01 } from "./DetailTable_WMS1020_R01";
import { LotTable_WMS1020_R01 } from "./LotTable_WMS1020_R01";
import { SmallTitleSpan, blueButtonClass, grayButtonClass } from "src/components/common/common";
import { InputForm } from "src/components/common/form/input/InputForm";


export const Container_WMS1020_R01 = () => {

	const {
		syncInitialData,
		lotTotalQty,
		applyLotTotalQty,
		selectedWMS1020_R01DetailList,
	} = useWMS1020_R01Store();

	const { tabList, setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'WMS1020_R01',
		type: 'width',
		storageKey: 'WMS1020_R01-split-width',
		min: 5,
		max: 80,
		default: 27
	} as const;
	const gridRef = useRef<AgGridReact<WMS1020_R01HeaderDto>>(null);
	const lotGridRef = useRef<AgGridReact<WMS1020_R01LotDto>>(null);
	const detailGridRef = useRef<AgGridReact<WMS1020_R01DetailDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const V_RESIZER = {
		code: 'WMS1020_R01',
		type: 'height',
		storageKey: 'WMS1020_R01-info-split-height',
		min: 5,
		max: 80,
		default: 30
	} as const;
	const rightTopRef = useRef<HTMLDivElement>(null);
	const isVResizing = useRef(false);

	const { 
		splitValue: vSplitValue,
		handleMouseDown: handleVMouseDown,
	} = useMouseContent({
		resizer: V_RESIZER,
		isResizing: isVResizing,
		containerRef: infoRef,
		infoRef: rightTopRef
	});

	const RESIZER_LOT = {
		code: 'WMS1020_R01_lot',
		type: 'width',
		storageKey: 'WMS1020_R01-detail2-split-height',
		min: 5,
		max: 80,
		default: 70
	} as const;
	const lotInfoRef = useRef<HTMLDivElement>(null);
	const isLotResizing = useRef(false);

	const { 
		splitValue: lotSplitValue,
		handleMouseDown: handleLotMouseDown,
	} = useMouseContent({
		resizer: RESIZER_LOT,
		isResizing: isLotResizing,
		containerRef: infoRef,
		infoRef: lotInfoRef
	});

	const {
		clickable, setClickable,
		handleExcelClick,
		fetchData,
		defaultWMS1020_R01HeaderRow,
		defaultWMS1020_R01DetailRow,
		defaultWMS1020_R01LotRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleInsertClick,
		handleSaveClick,
		handleDetailInfoCode,
		handleFetchDetailList,
		handleFetchLotList,
	} = Content_WMS1020_R01({
		gridRef,
		lotGridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	});

	const lotTotalQtyWrapperRef = useRef<HTMLDivElement>(null);

	const isLotTotalQtyEditable = selectedWMS1020_R01DetailList.length > 0;

	const commitLotTotalQty = useCallback(() => {
		const input = lotTotalQtyWrapperRef.current?.querySelector('input');
		input?.blur();
	}, []);

	useMemo(() => { syncInitialData(); }, []);

	return <div className={`content-container`}>
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={() => {}} //onCreateClick={handleCreateClick} < 예외입고 과정 알려주기 전까지 잠그기
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={() => {}}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_WMS1020_R01 onEnterKeyDown={() => { fetchData(); }} />

		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_WMS1020_R01 gridRef={gridRef} handleCreateClick={handleCreateClick} defaultWMS1020_R01HeaderRow={defaultWMS1020_R01HeaderRow()} />
			</div>
			{/* 리사이저 */}
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				data-comment="리사이저"
			/>
			<div className="h-full flex flex-col gap-[4px]" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				<div style={{ height: `${vSplitValue}%`, maxHeight: `${vSplitValue}%` }} ref={rightTopRef}>
					<Info_WMS1020_R01 
						editable={false}
						defaultWMS1020_R01HeaderRow={defaultWMS1020_R01HeaderRow()}
						handleDetailInfoCode={handleDetailInfoCode} handleFetchDetailList={handleFetchDetailList}
					/>
				</div>
				{/* 리사이저 */}
				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleVMouseDown("UD", e.nativeEvent) }
				/>
				<div style={{ height: `${100 - vSplitValue}%` }} className="pb-[12px] flex flex-1 gap-[4px] min-w-0">
					<div className="h-full" style={{ width: `${lotSplitValue}%` }} ref={lotInfoRef}>
						<DetailTable_WMS1020_R01 
							detailGridRef={detailGridRef} 
							defaultWMS1020_R01DetailRow={defaultWMS1020_R01DetailRow()}
							handleFetchLotList={handleFetchLotList}
						/>
					</div>
					{/* 리사이저 */}
					<div
						className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300 h-full"
						onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleLotMouseDown('LR', e.nativeEvent)}
						data-comment="리사이저"
					/>
					<div className="h-full flex flex-col gap-[4px]" style={{ width: `${100 - lotSplitValue}%` }}>
						<div className="flex items-center gap-[8px]">
							<SmallTitleSpan> 입고 Lot 입력 </SmallTitleSpan>
							<div ref={lotTotalQtyWrapperRef} className="flex items-center gap-[4px] mr-[12px]">
								<InputForm
									title="주문잔량"
									value={lotTotalQty}
									editable={isLotTotalQtyEditable}
									numericCommitOnBlur
									onChange={(e) => {
										const qty = Number(e.target.value.replace(/,/g, '')) || 0;
										applyLotTotalQty(qty);
									}}
									onKeyDown={(e) => {
										if (e.key === 'Enter') {
											e.preventDefault();
											commitLotTotalQty();
										}
									}}
									wrapperOption={{
										wrapperStyle: "w-[150px] min-w-[150px]",
										titleStyle: "w-[70px] min-w-[70px] text-left",
										inputStyle: "w-[70px] min-w-[70px]",
									}}
								/>
								<button
									type="button"
									onClick={commitLotTotalQty}
									disabled={!isLotTotalQtyEditable}
									className={`h-[20px] shrink-0 rounded-[4px] px-[10px] text-[12px] font-semibold text-white ${
										isLotTotalQtyEditable ? blueButtonClass : grayButtonClass
									}`}
								>
									적용
								</button>
							</div>
						</div>
						<LotTable_WMS1020_R01 
							lotGridRef={lotGridRef}
							defaultWMS1020_R01LotRow={defaultWMS1020_R01LotRow()}
							clickable={clickable}
							setClickable={setClickable}
							handleInsertClick={handleInsertClick}
						/>
					</div>
				</div>
			</div>
		</div>
		<Message />
	</div>
}